module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAoAAAAGCAYAAAD68A/GAAAAjklEQVQYV03MO04CUBCG0fOXFga0oMWGBRiBwoRoWIELcK1EQ2LhIy6ABlsLg6GgHHPNxTjdTM58qap7fGGdZO/fVNUpFjhPVd3hAu94TnJotqpOMMcltg2e4RoTvOGlR2e4wgZP6d8D3GKM1w6n+MBDku9f2PEQN73cTq30mGTXlj/Y8QjL/rtK8nkM/QDHgCy7/nFWBgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/admin/pullDown.png
// module id = pdCD
// module chunks = 2